module.exports = "./img/f5e3bf3832d710c7cb26bfe6109a466a.png";